import { Moon, Sun } from 'lucide-react'
import { useTheme } from '../../app/providers/themeProvider'
import { Switch } from '@/components/ui/switch'

export function ModeToggle() {
  const { theme, setTheme } = useTheme()

  const isDarkMode = theme === 'dark'

  const handleToggle = () => {
    setTheme(isDarkMode ? 'light' : 'dark')
  }

  return (
    <Switch id="theme-toggle" checked={isDarkMode} onCheckedChange={handleToggle} className="relative">
      {isDarkMode ? <Moon className="size-3 text-white" /> : <Sun className="size-3 text-black" />}
    </Switch>
  )
}
